<div class="body-wrapper">
  <!--First Row-->
  <div class="row">
    <div class="box-container col-xs-12 col-sm-6 col-md-3" *ngFor="let category of productCategory?.categories">
      <a [routerLink]="['/build-and-buy/products',category.id,category.description]">
        <div class="boxTitle">
          <h4>
            {{category.description}}
          </h4>
        </div><!--end title-->
        <div class="boxBody">
          <!--<img src="{{category.imageUrl}}" class="img-size" alt="{{category.imageUrl}}">-->
          <img src="{{category.imageUrl}}" class="img-size">
        </div><!--end boxBody-->
      </a>
    </div><!--end col-->
  </div>
</div>
